<template lang="pug">
  div(class="col d-flex align-items-center justify-content-center pb-4 flex-wrap")
    div(class="payment-result-stage text-center py-4 w-100" v-if="!draw")
      h4(class="font-weight-bold mb-4" v-if="cardSuccess") 感謝您的訂購！
      h4(class="font-weight-bold mb-4 text-warning" v-else-if="paymentPending") 付款確認中
      h4(class="font-weight-bold mb-4 text-danger" v-else) {{ $parent.stepText[0] }}
      div(v-if="cardSuccess")
        div(class="py-2" v-if="ShoppingResultViews.data && ShoppingResultViews.data[0]")
          div(class="" v-html="ShoppingResultViews.data[0].content")
      div(v-else-if="paymentPending")
        div(class="payment-return-loading py-5" v-if="manualReturnChecking")
          div(class="spinner-border text-success" role="status" aria-label="正在確認付款結果")
          p(class="font-weight-bold mt-4 mb-2") 正在確認交易結果
          p(class="text-muted mb-0") 請稍候，請勿關閉或重新整理頁面。
        div(class="py-2" v-else)
          p(class="mb-2") 訂單已建立，付款結果尚在確認中，請勿重複下單。
          p(class="mb-2" v-if="orderNumber") 訂單編號：{{ orderNumber }}
          p(class="mb-2" v-if="paymentStatusMessage") {{ paymentStatusMessage }}
          p(class="mb-0" v-else) 系統正在確認付款結果。
          div(class="d-flex flex-column align-items-center pt-3")
            button(class="btn btn-success my-1 max-w-300 w-100" type="button" :disabled="checkingPayment" @click="refreshPaymentResult")
              span(v-if="checkingPayment") 查詢中...
              span(v-else) 重新查詢付款結果
            router-link(class="btn btn-outline-success my-1 max-w-300 w-100" to="/member/shopcart/step/1") 返回購物車
            router-link(class="btn btn-outline-success my-1 max-w-300 w-100" to="/member/order/list") 前往訂單查詢
      div(v-else)
        div(class="py-2")
          p(class="font-weight-bold mb-0") 訂購失敗，請重新下單。
    div(class="bg-contain container-fluid w-100" style="background-repeat: no-repeat;background-size: cover;background-position: bottom;" v-else :style="{backgroundImage: `url(${images.DrawBg})`}")
      div(class="mx-auto pt-4" style="max-width: 320px;")
        img(class="w-100" :src="images.DrawSubject")
        div(class="draw-text text-center py-3")
          span 您共有
          span {{ opportunity }}
          span 次抽獎機會，剩下
          span {{ leftCount }}
          span 次
      div(class="row py-3")
        div(class="col-auto py-3 mx-auto red-package" :class="{open: state}" v-for="(state, index) in redPackages")
          button(class="btn btn-icon outline-none" type="button" v-if="state === 2")
            img(class="" :src="images.RedPackageOpen" width="60")
          button(class="btn btn-icon outline-none" type="button" :disabled="!leftCount" v-else @click="openPackage(index)")
            img(class="event-none" :src="images.RedPackage" width="60")
      div(class="row py-3")
        div(class="col-auto py-3 mx-auto" v-for="item in drawProductList")
          div(class="d-flex")
            div(class="col-auto mx-auto")
              div(class="text-center")
                img(class="" v-if="item.images && item.images[0] && item.images[0].image" :src="item.images[0].image" width="50")
                img(class="" v-else :src="defaultImage" width="50")
              div(class="py-2")
                span(class="ml-2") {{ item.name }}
                span(class="ml-2") X1
      div(class="d-flex justify-content-between align-items-end py-3")
        div(style="max-width: 100px;")
          img(class="w-100" :src="images.DragonLeft")
        div(style="max-width: 100px;")
          button(class="btn btn-icon outline-none" type="button" :disabled="!leftCount" @click="autoOpenPackage")
            img(class="w-100" :src="images.DrawBtn")
        div(style="max-width: 100px;")
          img(class="w-100" :src="images.DrawRight")
    div(class="col-12" v-if="!leftCount && !manualReturnChecking")
      div(class="d-flex flex-column align-items-center py-3")
        router-link(class="btn btn-success my-2 max-w-300 w-100" to="/member/order/list" v-if="cardSuccess") 前往購物紀錄
        router-link(class="btn btn-success my-2 max-w-300 w-100" to="/member/shopcart/step/1" v-if="failedPaymentResult") 返回購物車
        router-link(class="btn btn-outline-success my-2 max-w-300 w-100" to="/home") 回首頁
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import DrawBg from '@/assets/draw/draw-bg.svg'
import DrawBtn from '@/assets/draw/draw-btn.svg'
import DrawSubject from '@/assets/draw/draw-subject.png'
import DragonLeft from '@/assets/draw/dragon-left.png'
import DrawRight from '@/assets/draw/dragon-right.png'
import RedPackage from '@/assets/draw/red-package.png'
import RedPackageOpen from '@/assets/draw/red-package-open.png'
import { getOrdersById, getOrdersSearch, getActivitiesById, getProductsById, deleteShopcartAll } from '../../../api'
import defaultImage from '@/assets/images/default.png'
import {
  clearPaymentConfirmingLock,
  getPaymentConfirmingLock,
  resolveOrderPaymentState,
  findExactPaymentOrder,
  setPaymentConfirmingLock
} from '@/library/payment-confirming-lock'

const PAYMENT_RETURN_COMPLETED_KEY = 'shop-cart-payment-return-completed'
const MANUAL_RETURN_CHECK_ATTEMPTS = 3
const MANUAL_RETURN_CHECK_INTERVAL = 3000

export default {
  data () {
    return {
      defaultImage,
      draw: false,
      images: {
        DrawBg,
        DrawBtn,
        DrawSubject,
        DragonLeft,
        DrawRight,
        RedPackage,
        RedPackageOpen
      },
      redPackages: [0, 0, 0, 0, 0],
      orderNumber: this.$route.query.order_no,
      cardSuccess: false,
      paymentPending: true,
      checkingPayment: false,
      manualReturnChecking: true,
      paymentStatusMessage: '',
      paymentPollingTimer: null,
      paymentPollingStartedAt: 0,
      manualReturnCheckId: 0,
      failedPaymentResult: false,
      browserHistoryNavigation: false,
      opportunity: 0,
      leftCount: 0,
      drawProductList: [],
      lotteryProductList: []
    }
  },
  created () {
    this.getListModel({ name: 'ShoppingResultViews' })
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    window.addEventListener('popstate', this.handleBrowserHistoryNavigation, true)
  },
  beforeDestroy () {
    this.manualReturnCheckId += 1
    this.stopPaymentPolling()
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    window.removeEventListener('popstate', this.handleBrowserHistoryNavigation, true)
  },
  beforeRouteLeave (to, from, next) {
    if (this.failedPaymentResult && this.browserHistoryNavigation && to.path !== '/member/shopcart/step/1') {
      next('/member/shopcart/step/1')
      return
    }
    next()
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler () {
        if (this.failedPaymentResult && this.browserHistoryNavigation) {
          this.browserHistoryNavigation = false
          this.$router.replace('/member/shopcart/step/1')
          return
        }
        this.browserHistoryNavigation = false
        this.initializePaymentResult()
      }
    }
  },
  computed: {
    ...mapState({
      ShoppingResultViews: state => state.model.ShoppingResultViews,
      ShopCarts: state => state.model.ShopCarts
    })
  },
  methods: {
    ...mapActions(['getListModel']),
    async initializePaymentResult () {
      sessionStorage.removeItem('shop-cart-payment-navigation-started')
      this.manualReturnCheckId += 1
      this.stopPaymentPolling()
      const query = this.$route.query || {}
      const retCode = query.ret_code || query.retcode || query.retCode
      const orderId = query.order_id
      const orderNumber = query.order_no || query.ordernumber

      this.orderNumber = orderNumber || this.orderNumber

      // Step5 元件會被購物流程重複使用，先依新網址重設畫面，
      // 避免沿用上一筆「交易失敗」結果後才等待訂單狀態查詢。
      this.cardSuccess = false
      // 後端結果回來前保持 loading，不可落入預設失敗畫面。
      this.paymentPending = true
      this.manualReturnChecking = true
      this.failedPaymentResult = false
      this.paymentStatusMessage = ''
      this.draw = false

      if (query.payment_return_check === '1') {
        const completedResult = this.getCompletedPaymentReturn(orderId, orderNumber)
        if (completedResult) {
          this.goToPaymentResult(completedResult.ret_code, orderId, orderNumber)
          return
        }
      }

      if (query.payment_pending === '1') {
        this.showPendingResult({
          id: orderId,
          order_number: orderNumber
        })
      }

      if (query.payment_return_check === '1') {
        this.paymentStatusMessage = '正在確認交易結果，請稍候。'
        this.startManualReturnCheck(orderId, orderNumber)
        return
      }

      if (query.error === '500') {
        this.showFailedResult('訂單失敗')
        return
      }

      if (retCode) {
        if (retCode === '00') {
          if (!orderId && orderNumber) {
            const state = await this.showResultByOrderNumber(orderNumber)
            if (state === 'pending') this.startPaymentPolling()
            return
          }
          await this.showPaidResult(orderId)
        } else {
          this.showFailedResult('交易失敗')
        }
        return
      }

      if (orderId) {
        const state = await this.showResultByOrder(orderId)
        if (state === 'pending') {
          this.startPaymentPolling()
        }
        return
      }

      if (orderNumber) {
        const state = await this.showResultByOrderNumber(orderNumber)
        if (state === 'pending') {
          this.startPaymentPolling()
        }
      }
    },
    async showResultByOrderNumber (orderNumber, renderResult = true) {
      try {
        const response = await getOrdersSearch({
          order_number: orderNumber
        })
        const data = response && response.data
        const orderData = findExactPaymentOrder(data, orderNumber)

        if (orderData && orderData.id) {
          return this.showResultByOrder(orderData.id, renderResult)
        }

        if (renderResult) {
          this.showPendingResult(orderData)
        }
        return 'pending'
      } catch (error) {
        if (renderResult) {
          this.showPendingResult(null, '暫時無法取得付款結果，請稍後重新查詢。')
        }
        return 'pending'
      }
    },
    async showResultByOrder (orderId, renderResult = true) {
      try {
        const response = await getOrdersById(orderId)
        const orderData = response && response.data
        if (!orderData || String(orderData.id) !== String(orderId)) {
          if (renderResult) this.showPendingResult({ id: orderId })
          return 'pending'
        }
        const state = resolveOrderPaymentState(orderData)

        if (state === 'paid') {
          if (renderResult) {
            await this.showPaidResult(orderId, orderData)
          }
          return 'paid'
        }

        if (state === 'failed') {
          if (renderResult) {
            this.showFailedResult('交易失敗')
          }
          return 'failed'
        }

        if (renderResult) {
          this.showPendingResult(orderData)
        }
        return 'pending'
      } catch (error) {
        if (renderResult) {
          this.showPendingResult(null, '暫時無法取得付款結果，請稍後重新查詢。')
        }
        return 'pending'
      }
    },
    async startManualReturnCheck (orderId, orderNumber) {
      const checkId = ++this.manualReturnCheckId
      this.showPendingResult({ id: orderId, order_number: orderNumber })
      this.checkingPayment = true
      this.manualReturnChecking = true

      for (let attempt = 0; attempt < MANUAL_RETURN_CHECK_ATTEMPTS && checkId === this.manualReturnCheckId; attempt += 1) {
        if (attempt > 0) {
          await new Promise(resolve => setTimeout(resolve, MANUAL_RETURN_CHECK_INTERVAL))
        }

        let state = 'pending'
        if (orderId) {
          state = await this.showResultByOrder(orderId, false)
        } else if (orderNumber) {
          state = await this.showResultByOrderNumber(orderNumber, false)
        }

        if (checkId !== this.manualReturnCheckId) {
          return
        }
        if (state === 'paid') {
          await this.goToPaymentResult('00', orderId, orderNumber)
          return
        }
        if (state === 'failed') {
          await this.goToPaymentResult('user_cancel', orderId, orderNumber)
          return
        }
      }

      if (checkId !== this.manualReturnCheckId) {
        return
      }

      await this.goToPaymentResult('user_cancel', orderId, orderNumber)
    },
    async goToPaymentResult (retCode, orderId, orderNumber) {
      this.checkingPayment = false
      this.manualReturnChecking = false
      sessionStorage.setItem(PAYMENT_RETURN_COMPLETED_KEY, JSON.stringify({
        order_id: orderId || '',
        order_number: orderNumber || '',
        ret_code: retCode
      }))
      await this.$router.replace({
        path: '/member/shopcart/step/5',
        query: {
          order_id: orderId,
          order_no: orderNumber,
          ret_code: retCode
        }
      })
    },
    getCompletedPaymentReturn (orderId, orderNumber) {
      try {
        const completedResult = JSON.parse(sessionStorage.getItem(PAYMENT_RETURN_COMPLETED_KEY) || 'null')
        if (!completedResult) {
          return null
        }

        const matchesOrderId = orderId && String(completedResult.order_id) === String(orderId)
        const matchesOrderNumber = orderNumber && String(completedResult.order_number) === String(orderNumber)
        return matchesOrderId || matchesOrderNumber ? completedResult : null
      } catch (error) {
        sessionStorage.removeItem(PAYMENT_RETURN_COMPLETED_KEY)
        return null
      }
    },
    async showPaidResult (orderId, orderData) {
      if (!orderData && orderId) {
        try {
          const response = await getOrdersById(orderId)
          orderData = response && response.data
        } catch (error) {
          this.showPendingResult({ id: orderId }, '暫時無法取得付款結果，請稍後重新查詢。')
          this.startPaymentPolling()
          return
        }
      }
      if (orderId || orderData) {
        const state = resolveOrderPaymentState(orderData)
        if (state === 'failed') {
          this.showFailedResult('交易失敗')
          return
        }
        if (state !== 'paid') {
          this.showPendingResult(orderData || { id: orderId })
          this.startPaymentPolling()
          return
        }
      }
      localStorage.removeItem('order-response')
      clearPaymentConfirmingLock()
      this.cardSuccess = true
      this.paymentPending = false
      this.manualReturnChecking = false
      this.failedPaymentResult = false
      this.$parent.step = 5

      await this.clearPaidCart()
      this.clearCheckoutStorage()

      if (!orderData || !orderData.order_items) {
        return
      }

      const activities = await Promise.all(
        orderData.order_items.map((item) => {
          if (item.activity_id) {
            return getActivitiesById(item.activity_id)
          }
          return Promise.resolve()
        })
      )

      orderData.order_items.forEach((item, index) => {
        if (activities[index]) {
          item.activity = activities[index].data
        }
      })

      const orderItems = orderData.order_items.filter(item => item && item.activity && item.activity.ruleable_type.includes('RuleRaffle'))
      if (orderItems.length) {
        const producResult = await Promise.all(orderItems.map(item => getProductsById(item.product_id)))
        const productList = producResult.map((item, index) => {
          if (item && item.data) {
            item.data.product_quantity = orderItems[index].quantity
            return item.data
          }
          return {
            product_quantity: 0
          }
        })
        this.lotteryProductList = productList.reduce((acc, item) => {
          return acc.concat(new Array(item.product_quantity).fill(item))
        }, [])
        this.lotteryProductList = this.shuffle(this.lotteryProductList)
        this.opportunity = this.lotteryProductList.length
        this.leftCount = this.lotteryProductList.length
        this.draw = true
      }
    },
    showPendingResult (orderData, message = '') {
      const lock = getPaymentConfirmingLock()
      const orderId = orderData && orderData.id
      const orderNumber = orderData && orderData.order_number

      this.cardSuccess = false
      this.paymentPending = true
      this.manualReturnChecking = false
      this.failedPaymentResult = false
      this.paymentStatusMessage = message
      this.$parent.step = 5
      this.orderNumber = orderNumber || this.orderNumber

      setPaymentConfirmingLock({
        order_id: orderId || (lock && lock.order_id),
        order_number: orderNumber || (lock && lock.order_number) || this.orderNumber,
        cart_items: orderData && orderData.order_items ? orderData.order_items : lock && lock.cart_items
      })
    },
    showFailedResult (message) {
      this.stopPaymentPolling()
      clearPaymentConfirmingLock()
      // 此次付款流程已結束；再次結帳必須使用新的冪等識別碼，
      // 避免後端誤判為重送上一筆失敗訂單並沿用原銀行訂單編號。
      this.$parent.model.client_order_key = uuidv4()
      this.cardSuccess = false
      this.paymentPending = false
      this.manualReturnChecking = false
      this.failedPaymentResult = true
      this.$parent.step = 0
      this.$parent.stepText[0] = message
      this.clearCheckoutStorage()
    },
    async refreshPaymentResult () {
      if (this.checkingPayment) {
        return
      }

      this.checkingPayment = true
      const query = this.$route.query || {}
      const lock = getPaymentConfirmingLock()
      const orderId = query.order_id || (lock && lock.order_id)
      const orderNumber = query.order_no || query.ordernumber || (lock && lock.order_number)

      let state = 'pending'
      try {
        if (orderId) {
          state = await this.showResultByOrder(orderId)
        } else if (orderNumber) {
          state = await this.showResultByOrderNumber(orderNumber)
        } else {
          this.showPendingResult(null, '缺少訂單資料，請至訂單查詢確認付款狀態。')
        }
      } finally {
        this.checkingPayment = false
      }

      if (state !== 'pending') {
        this.stopPaymentPolling()
      }
      return state
    },
    startPaymentPolling () {
      this.stopPaymentPolling()
      this.paymentPollingStartedAt = Date.now()
      this.scheduleNextPaymentCheck()
    },
    scheduleNextPaymentCheck () {
      if (!this.paymentPending) {
        return
      }
      if (Date.now() - this.paymentPollingStartedAt >= 30000) {
        this.paymentStatusMessage = '付款結果仍在確認中，您可以稍後重新查詢或前往訂單查詢查看。'
        return
      }
      this.paymentPollingTimer = setTimeout(async () => {
        const state = await this.refreshPaymentResult()
        if (state === 'pending') {
          this.scheduleNextPaymentCheck()
        }
      }, 5000)
    },
    stopPaymentPolling () {
      if (this.paymentPollingTimer) {
        clearTimeout(this.paymentPollingTimer)
        this.paymentPollingTimer = null
      }
    },
    handleVisibilityChange () {
      if (document.visibilityState === 'visible' && this.paymentPending) {
        this.refreshPaymentResult()
      }
    },
    handleBrowserHistoryNavigation () {
      this.browserHistoryNavigation = true
    },
    async clearPaidCart () {
      await deleteShopcartAll()
      this.$store.dispatch('getListModel', {
        name: 'ShopCarts'
      })
    },
    clearCheckoutStorage () {
      localStorage.removeItem('name')
      localStorage.removeItem('postal_code')
      localStorage.removeItem('receiver_phone')
      localStorage.removeItem('addresscity')
      localStorage.removeItem('addressdistrict')
      localStorage.removeItem('addressaddress')
      localStorage.removeItem('invoice_accept_type')
      localStorage.removeItem('invoicepostal_code')
      localStorage.removeItem('invoicecity')
      localStorage.removeItem('invoicedistrict')
      localStorage.removeItem('invoiceaddress')
      localStorage.removeItem('currentOfficesInvoiceAddress')
      localStorage.removeItem('sale_territory')
      localStorage.removeItem('payment')
      localStorage.removeItem('installment')
      localStorage.removeItem('total_price_new')
    },
    shuffle (array) {
      let currentIndex = array.length
      let randomIndex = 0
      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex--

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]]
      }

      return array
    },
    openPackage (index) {
      this.redPackages[index] = 1
      this.leftCount--
      this.$forceUpdate()
      setTimeout(() => {
        this.redPackages[index] = 2
        this.drawProductList.push(this.lotteryProductList.pop())
        setTimeout(() => {
          this.redPackages[index] = 0
          this.$forceUpdate()
        }, 2000)
      }, 2000)
    },
    autoOpenPackage () {
      this.leftCount = 0
      for (let index = 0; index < this.lotteryProductList.length; index++) {
        if (index < 5) {
          this.redPackages[index] = 1
        }
        setTimeout(() => {
          if (index < 5) {
            this.redPackages[index] = 2
          }
          this.drawProductList.push(this.lotteryProductList.pop())
        }, index * 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-result-stage {
  min-height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.payment-return-loading {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.draw-text {
  color:#ae0000;
  letter-spacing: 2px;
}
.red-package{
  button {
    animation: red-packages-shake 2s infinite linear;
  }
  &:nth-of-type(1) button{
    animation-delay: 0.2s;
  }
  &:nth-of-type(2) button{
    animation-delay: 0.4s;
  }
  &:nth-of-type(3) button{
    animation-delay: 0.6s;
  }
  &:nth-of-type(4) button{
    animation-delay: 0.8s;
  }
  &:nth-of-type(5) button{
    animation-delay: 1s;
  }
  &.open {
    animation: red-packages-open 2s linear;
  }
}
@keyframes red-packages-shake {
  0%   { transform: translateY(0); }
  50%  { transform: translateY(10px); }
  100% { transform: translateY(0); }
}

@keyframes red-packages-open {
  12%  { transform: rotate(5deg); }
  25%  { transform: rotate(0); }
  37%  { transform: rotate(-5deg); }
  50% { transform: rotate(0); }
  62%  { transform: rotate(5deg); }
  75%  { transform: rotate(0); }
  87%  { transform: rotate(-5deg); }
  100% { transform: rotate(0); }
}
</style>
